import { HttpLocalCancelException, InvocationException, UnrecoverableException } from '@core/Exceptions'
import AsyncRetry from 'async-retry'

const MAXIMUM_NUMBER_OF_RETRIES = 3

export const TRANSMISSION_MAXIMUM_NUMBER_OF_RETRIES = 5

export function retry<Fn extends (...args: unknown[]) => Promise<unknown>>(
  validateResult: (...args: unknown[]) => boolean,
  retryInterceptor?: (attempt: number, args: unknown[]) => Promise<unknown[]> | unknown[],
  retries = MAXIMUM_NUMBER_OF_RETRIES
): MethodDecorator {
  return function (target, propertyKey, descriptor: PropertyDescriptor) {
    const sourceMethod = descriptor.value
    let result: ReturnType<Fn> | undefined

    descriptor.value = async function (...args: unknown[]) {
      return await AsyncRetry(
        async (bail, attempt) => {
          let argumentList: unknown[] = args

          if (retryInterceptor) {
            argumentList = (await retryInterceptor(attempt, args)) || []
          }

          try {
            result = await sourceMethod.apply(this, argumentList)
          } catch (error) {
            console.log(
              `[retry] ${new Date().toLocaleString()} `,
              sourceMethod,
              `invoke failed ${attempt} times`,
              error
            )

            if (error instanceof UnrecoverableException || error instanceof HttpLocalCancelException) {
              console.log(`[retry] ${new Date().toLocaleString()} `, `give up retry on ${attempt} times,`, error)

              bail(error)

              return
            }
            throw new InvocationException()
          }

          if (validateResult(result)) return result
          console.log(`[retry] ${new Date().toLocaleString()} `, sourceMethod, `invoke failed ${attempt} times`, result)

          throw new InvocationException()
        },
        { retries }
      )
    }
  }
}
